// src/stores/counter-store.ts
import { createStore } from "zustand/vanilla";

export type UserState = {
  user: {
    id: string;
    email: string;
    name?: string;
    avatar?: string;
    user_type: "admin" | "expert" | "user" | null;
    type?: string;
    created_at: Date;
    updated_at?: Date;
  };
};

export type UserAction = {
  updateUser: (userData: Partial<UserState>["user"]) => void;
};

export type UserStore = UserState & UserAction;

export const createUserStore = (initState: UserState) => {
  return createStore<UserStore>()((set) => ({
    ...initState,
    updateUser: (userData) =>
      set((state) => ({
        user: state.user
          ? { ...state.user, ...userData }
          : (userData as UserState["user"]),
      })),
  }));
};
